var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex flex-col items-center justify-center h-full"},[_c('div',{staticClass:"relative flex flex-grow items-center justify-between h-full bg-bg",class:{
      'items-stretch my-6 w-mobile-container max-h-mobile-container rounded-2.25xl border-2 bg-bg border-bg overflow-hidden':
        !_vm.isMobile,
      'flex-col w-full': _vm.isMobile,
    },attrs:{"id":"pageWrapper"}},[(_vm.showCancelButton)?_c('a',{class:[
        'absolute',
        'z-20',
        'left-3',
        'top-3',
        _vm.resignLinkTextColor,
        'hover:no-underline',
        'underline',
        'text-sm',
        'leading-none',
        'opacity-60',
      ],attrs:{"href":"about:blank"}},[_vm._v(" "+_vm._s(_vm.$t('common.resign'))+" ")]):_vm._e(),_vm._t("logo"),_c('div',{staticClass:"z-10 flex flex-col w-full bg-white overflow-y-auto",class:{
        'flex-grow absolute h-screen': _vm.isFullscreenDropdown && _vm.isMobile,
        'rounded-2xl relative': !_vm.isMobile,
        'min-h-mobile-content': _vm.isMobile,
      },attrs:{"id":"contentContainer"}},[_c('div',{staticClass:"form-wrapper",class:{ static: _vm.isMobile }},[_vm._t("form"),_vm._t("footer")],2)])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }